<template>
    <div class="content">
        <Row>
            <Col span="5" class="mainLeft">
            <!-- <div class="logo" :style="{backgroundImage:'url('+host+'/'+logoUrl+')'}"></div> -->
            <h3 class="comName">{{name}}</h3>
            <div class="types">
                <p>企业成员: <span> {{members}}人</span></p>
            </div>
            <div class="types">
                主体类型：<span>{{business_scope}} 企业</span>
            </div>
            <div v-if="(isActive === '0' || isActive === '3')"  v-hasPermission="'web_activation'" class="types" @click="toActivation">
                激活状态：<span style="cursor: pointer;color:#3399ff">{{isActive === '0' ? '未激活' : '审核失败'}} </span>
            </div>
            <div v-if="isActive === '1' || isActive === '2'" class="types">
                激活状态：<span>{{isActive === '2' ? '已激活' : '审核中'}} </span>
            </div>
            <p>
                <a href="javascript:void(0)"  v-hasPermission="'web_companies_show'" @click="toMyBusinessInfo()">查看企业详情</a>
            </p>
            <p>
                <Button type="primary" style="margin-top:20px;"><a :href="versionUrl" style="color: #ffffff!important;">下载客户端</a></Button>
            </p>
            </Col>
            <Col span="19" class="mainRight">
            <h3>欢迎开始使用易采智电售电管理系统</h3>
            <div class="buzou">
                <Steps :current="1">
                    <Step title="下载客户端"></Step>
                    <Step title="设置权限"></Step>
                    <Step title="使用客户端"></Step>
                </Steps>
            </div>
            <div class="seavers">
                <p class="useTip">常用入口</p>
                <span class="addUser"  v-hasPermission="'web_member_add'" @click="toAdds()"> <a>添加成员</a> </span>
            </div>
            </Col>
        </Row>

    </div>
</template>

<script>
    import {HOST} from '@/config';

    export default {
        name: 'MainInfo',
        data() {
            return {
                name: '',
                business_scope: '',
                logoUrl: '',
                members: 0,
                versionUrl:'',
                isShow:true,
                isActive:0,
                memberList:true,
                host:HOST
            }
        },
        methods: {
            //跳转到企业激活页
            toActivation(){
                this.$router.push('activation')
            },
            toAdds() {
                this.$router.push('memberAdd')
            },
            toMyBusinessInfo() {
                this.$router.push('myBusiness')
            },
            getComInfo() {
                if(!sessionStorage.getItem('com_id')){
                    this.$router.push({
                        name:'login'
                    })
                }else{
                    this.$http.get(this.$api.COM_INFO + '\/' + sessionStorage.getItem('com_id')).then(res => {
                        console.log('公司信息', res);
                        let data = res.data.data;
                        this.name = data.com_name;
                        this.business_scope = data.business_scope;
                        this.logoUrl = data.logo;
                        this.members = data.members;
                        this.isActive = data.isActive;
                        this.$store.dispatch('setComInfo', res.data.data)
                    }, err => {
                        this.$api.errcallback(err)
                    });
                }

            },

            //切换首页，企业成员，成员权限页面
            changePage(page) {
                this.$store.dispatch('setPage', page);
                this.$router.push('member');
            },

            //判断用户是否有操作权限
            isOperation(){
                let permissionList = sessionStorage.getItem('permission');
                console.log(permissionList)
                //成员列表
                if(!permissionList.includes('web_member_list')){
                    this.memberList= false;
                }
            },
        },
        mounted() {
            this.$store.dispatch('setPage', '1');
            this.getComInfo();
            this.isOperation();
        },
        created(){
            $.post(HOST+"/api/login/versions", (res) => {
                console.log('获取到版本地址',res)
                if(res.status == 1){
                    this.versionUrl = res.info.url;
                }else{
                    console.log('未获取到版本地址')
                }
            })
        },
    }
</script>

<style scoped>
    .mainLeft {
        height: 654px;
        padding: 30px 26px;
        position: relative;
        background-color: #F9FAFC;
    }

    .mainLeft h3 {
        text-align: center;
        font-size: 14px;
        margin-bottom: 12px;
    }

    .mainRight {
        height: 654px;
        padding-top: 30px;
        padding-left: 42px;
        padding-bottom: 50px;
        padding-right: 42px;
        border-left: 1px dotted #E4E6E9;
    }

    .logo {
        width: 100%;
        height: 46px;
        background-color: #D8D8D8;
        margin-top: 20px;
        background-repeat: no-repeat;
        background-size: contain;
        border: 1px solid #E4E6E9;
    }

    .comName {
        line-height: 3;
        border-bottom: 1px solid #E4E6E9;

    }

    .chengyaun {
        color: #787878;
        height: 32px;
        font-size: 13px;
        border-bottom: 1px solid #E4E6E9;
    }

    .chengyaun p {
        line-height: 20px;
        margin-bottom: 12px;
    }

    .chengyaun span {
        color: black;

    }

    .types {
        border-bottom: 1px solid #E4E6E9;
        margin-bottom: 20px;
        line-height: 2;
        color: #787878;
        padding: 12px 0;
    }

    .types span {
        color: black;
        float: right;
    }

    .change {
        float: right;
        margin-right: 10px;
    }

    .downs {
        position: absolute;
        bottom: 50px;
        left: 50%;
        margin-left: -70px;
    }

    .mainRight h3 {
        font-size: 16px;
        margin-bottom: 12px;
    }

    .down a {
        display: inline-block;
        width: 33%;
        padding-left: 5%;
    }

    .buzou {
        margin: 37px;
    }

    .newsTip {
        line-height: 30px;
        color: #787878;
        border-bottom: 1px solid #E4E6E9;
    }

    .messageList li {
        height: 43px;
        line-height: 43px;
        border-bottom: 1px solid #E4E6E9;
    }

    .useTip {
        line-height: 30px;
        color: #787878;
        margin-bottom: 10px;
    }

    .seavers {
        margin-top: 26px;
    }

    .addUser {
        float: left;
        border: 1px solid #CCD0D6;
        border-radius: 4px;
        margin-left: 24px;
        margin-bottom: 24px;
        width: 202px;
        height: 64px;
        font-size: 14px;
        line-height: 64px;
        text-align: center;
        cursor: pointer;
         -webkit-box-sizing: border-box;
        box-sizing: border-box;
        vertical-align: middle;
    }

    .addUser i {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background-color: #f78181;
        color: #fff;
        font-size: 22px;
        line-height: 38px;
        text-align: center;
        margin-right: 10px;
    }
</style>






// WEBPACK FOOTER //
// src/components/mainPage/mainInfo.vue